export const iconFontAwesomeBuildingsHouseChimneyWindow = (
	<i className="fa-solid fa-house-chimney-window"></i>
);
